import { Box, Button, TextField, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { selectWeightsTab } from "../../../redux/selector";
import { actions } from "../../../redux/slice";
import { useStyles } from "./styles";

const WeightsTab = () => {
  const { t } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();
  const data = useSelector(selectWeightsTab);

  if (!data) {
    return null;
  }

  return (
    <Box className={styles.content}>
      <Box className={styles.section}>
        <Typography className={styles.sectionTitle}>
          {t("VECHILE_STATUS.DETAIL_TABS.WEIGHTS")}
        </Typography>
        <Box className={styles.fieldsRow}>
          {data.fields.map((field) => (
            <Box key={field.id} className={styles.field}>
              <Typography className={styles.label}>
                {t(field.labelKey)}
              </Typography>
              <TextField
                className={styles.input}
                value={field.value}
                onChange={(event) =>
                  dispatch(
                    actions.updateWeightFieldValue({
                      id: field.id,
                      value: event.target.value,
                    })
                  )
                }
                fullWidth
                variant="outlined"
              />
            </Box>
          ))}
        </Box>
      </Box>

      <Box className={styles.divider} />

      <Box className={styles.summaryRow}>
        <span className={styles.summaryPill}>{t(data.netWeightValueKey)}</span>
        <Typography className={styles.summaryLabel}>
          {t("VECHILE_STATUS.WEIGHTS.NET_WEIGHT_ADDED")}
        </Typography>
      </Box>

      <Button variant="contained" className={styles.saveButton}>
        {t("VECHILE_STATUS.WEIGHTS.SAVE")}
      </Button>
    </Box>
  );
};

export default WeightsTab;
